// NEW_FILE_JUSTIFIED: New messages feature component
import { memo } from 'react';
import { cn } from '@/lib/utils';
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import { ICON_SIDEBAR_ITEMS } from '@/constants/messagesMockData';
import type { IIconSidebarProps } from '@/@types/messages';

function IconSidebarBase({ activeView, onViewChange }: IIconSidebarProps) {
  return (
    <TooltipProvider>
      <div
        role="tablist"
        aria-label="Right panel view"
        aria-orientation="vertical"
        className="flex h-full w-14 shrink-0 flex-col items-center gap-3 border-l border-msg-panel-border bg-msg-panel-bg pt-4 px-2"
      >
        {ICON_SIDEBAR_ITEMS.map(item => {
          const Icon = item.icon;
          const isActive = activeView === item.id;

          return (
            <Tooltip key={item.id}>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  onClick={() => onViewChange(item.id)}
                  className={cn(
                    'flex h-10 w-10 items-center justify-center rounded-lg transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  )}
                  role="tab"
                  aria-label={item.label}
                  aria-selected={isActive}
                >
                  <Icon size={20} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="left">{item.label}</TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}

export const IconSidebar = memo(IconSidebarBase);
